import standardButtonReducer from "../../../helpers/standard-button-reducer";

const reducer = standardButtonReducer("EVENT_SAVE");

export default reducer;
